// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hfmBhD3p0rv28P {
  display: flex;
  align-items: center;
  padding: var(--ds-space-025, 2px) var(--ds-space-0, 0);
}
.wujlc4mHCPi5qo {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: var(--ds-space-025, 2px) var(--ds-space-075, 6px);
  border: none;
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-background-discovery-bold, #6e5dc6);
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
  color: var(--ds-text-inverse, #ffffff);
  font-size: 12px;
}
.q_sNaVbkcA4KO6 {
  display: flex;
  align-items: center;
  margin-right: var(--ds-space-negative-025, -2px);
  margin-left: var(--ds-space-100, 8px);
  margin-block: var(--ds-space-025, 2px);
  padding-inline: var(--ds-space-075, 6px);
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-background-accent-purple-subtle, #c97cf4);
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (color) otherwise low contrast in dark mode */
  color: #ffffff;
}
`, ""]);
// Exports
export var tooltip = `hfmBhD3p0rv28P`;
export var notificationTooltip = `wujlc4mHCPi5qo`;
export var tooltipShortcut = `q_sNaVbkcA4KO6`;
export default ___CSS_LOADER_EXPORT___;
